import PropTypes from "prop-types";
import { ResponsiveContainer, PieChart, Pie, Cell, Label } from "recharts";

const PercentageChangePieChart = ({ currentVal, comparingVal, title1, title2 }) => {
  const percentageDifference = Math.round((currentVal / comparingVal) * 100) - 100;

  const data = [
    {
      name: "Group A",
      value: currentVal,
      percentageDifference: Math.abs(percentageDifference),
    },
    {
      name: "Group B",
      value: comparingVal,
      percentageDifference: 100 - Math.abs(percentageDifference),
    },
  ];

  const preChar = percentageDifference > 0 ? "+" : "";

  return (
    <div
      style={{
        width: 250,
        height: 175,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}>
      {title1}
      <br />
      {title2}
      <div>
        <PieChart width={730} height={200}>
          <Pie
            data={data}
            // cx="50%"
            // cy="50%"
            dataKey="percentageDifference" // make sure to map the dataKey to "value"
            innerRadius={50} // the inner and outer radius helps to create the progress look
            outerRadius={80}
            startAngle={180}
            endAngle={0}>
            {data.map((entry, index) => {
              if (index === 1) {
                return <Cell key={`cell-${index}`} fill="gray" />;
              }
              return (
                <Cell key={`cell-${index}`} fill={percentageDifference > 0 ? "green" : "red"} />
              );
            })}
            <Label
              value={preChar + percentageDifference + "%"}
              position="center"
              fill="grey"
              style={{
                fontSize: "32px",
                fontWeight: "bold",
                fontFamily: "Roboto",
              }}
            />
          </Pie>
        </PieChart>
      </div>
    </div>
  );
};

export default PercentageChangePieChart;

PercentageChangePieChart.propTypes = {
  currentVal: PropTypes.number,
  comparingVal: PropTypes.number,
  title1: PropTypes.string,
  title2: PropTypes.string,
};
